// src/components/admin/AdminProtected.jsx
// Guard del panel /gestion. Verifica `userData.role === 'admin'` (que vive en
// Firestore /users/{uid}). Si NO es admin, renderiza un 404 disimulado para
// que un usuario sin permisos ni siquiera sepa que la ruta existe.
//
// Uso:
//   <Route path="/gestion" element={<AdminProtected><AdminPanel/></AdminProtected>} />

import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';

function NotFoundDisimulado() {
  // 404 visual mínimo, idéntico al estilo del NotFound público para no
  // delatar la existencia del panel.
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg, #fff)',
      color: 'var(--ink, #111)',
      fontFamily: 'inherit',
      flexDirection: 'column',
      gap: 12,
      textAlign: 'center',
      padding: 24,
    }}>
      <div style={{ fontSize: 56, fontWeight: 800, letterSpacing: '-0.04em' }}>404</div>
      <div style={{ fontSize: 16, color: 'var(--muted, #666)' }}>Página no encontrada</div>
      <a href="/" style={{ marginTop: 12, color: 'var(--accent, #FF6B2C)', fontWeight: 600 }}>
        Volver al inicio
      </a>
    </div>
  );
}

function LoadingMin() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#1A1D29',
      color: '#8B8E9C',
      fontSize: 13,
      fontFamily: 'inherit',
    }}>
      Cargando…
    </div>
  );
}

export default function AdminProtected({ children }) {
  const { user, userData, loading, isAdmin } = useAuth();

  // Mientras carga la sesión / el doc Firestore.
  if (loading) return <LoadingMin />;

  // Sin sesión → al login (con returnTo /gestion para que vuelva acá tras login).
  if (!user) return <Navigate to="/login" replace />;

  // Sesión cargada pero sin doc todavía (race: AuthContext puede tener user
  // pero userData=null por un instante mientras llega el snapshot).
  if (userData === null) return <LoadingMin />;

  // No es admin → 404 disimulado.
  if (!isAdmin) return <NotFoundDisimulado />;

  return children;
}
